import { render } from "./closeModal.vue?vue&type=template&id=0e210842"
import script from "./closeModal.vue?vue&type=script&lang=js"
export * from "./closeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__